
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-9 -8)","fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"#29AC64","cx":"24","cy":"23","r":"12"}}),_c('path',{attrs:{"fill":"#FFF","d":"M29.385 18l-7.808 7.776-2.962-2.957L17 24.431 21.577 29 31 19.612z"}})])])
          )
        }
      }
    